'use client';

import { Button, ButtonProps } from './button';
import { MouseEvent, MouseEventHandler, useMemo, useState } from 'react';

type ControlledButtonProps = {
  onClick: (event: MouseEvent<HTMLButtonElement, globalThis.MouseEvent>) => Promise<unknown>;
} & ButtonProps;

export function ControlledButton({ disabled, onClick: originalOnClick, ...props }: ControlledButtonProps) {
  const [isLoading, setIsLoading] = useState(false);
  const onClick = useMemo<MouseEventHandler<HTMLButtonElement>>(() => {
    if (typeof originalOnClick === 'function') {
      return async (e) => {
        setIsLoading(true);

        const result = await originalOnClick(e);

        setIsLoading(false);

        return result;
      };
    }

    return () => {};
  }, [originalOnClick]);

  return <Button disabled={isLoading || disabled} onClick={onClick} {...props} />;
}
